import NavBar from "./header/NavBar";

const Header = () => {
  return (
    <header>
      <NavBar />
    </header>
  );
};

export default Header;
